import { Divider, Stack } from "@mui/material";

import GrowerBoundarySection from "./GrowerBoundarySection";
import SidePanelSectionHeader from "./SidePanelSectionHeader";
import SiteBoundariesSection from "./SiteBoundariesSection";

interface DrawBoundaryPanelProps {}

const DrawBoundaryPanel: React.FC<DrawBoundaryPanelProps> = () => {
  return (
    <Stack spacing={1.5}>
      <SidePanelSectionHeader title="Define Boundaries" />
      <GrowerBoundarySection />
      <Divider />
      <SiteBoundariesSection />
    </Stack>
  );
};

export default DrawBoundaryPanel;
